<template>
    <v-tabs centered icons-and-text>
        <v-tabs-slider color="secondary"></v-tabs-slider>

        <v-tab href="#tab-1"> Prihlásenie
            <v-icon>perm_identity</v-icon>
        </v-tab>

        <v-tab href="#tab-2"> Registrácia
            <v-icon>lock_open</v-icon>
        </v-tab>

        <v-tab-item :value="'tab-1'" >
            <Login/>
        </v-tab-item>
        <v-tab-item :value="'tab-2'" >
            <Registration/>
        </v-tab-item>
    </v-tabs>
</template>

<script>
import Login from '@/views/auth/components/Login'
import Registration from '@/views/auth/components/Registration'
// import ForgotPassword from './ForgotPassword'
export default {
    data () {
        return {
        }
    },
    components: {
        Login,
        Registration,
        // ForgotPassword
    }
}
</script>
<style>
</style>
